// extracted by mini-css-extract-plugin
export default {"board":"TasksBoard_board__AeoCe","inner":"TasksBoard_inner__upgfn"};